"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matcherTermination = void 0;
const matcherTermination = () => null;
exports.matcherTermination = matcherTermination;
